export default __webpack_public_path__ + "static/media/Market launch.bae48348.mp4";